import './styles.scss';

export const SubTitle = ({ text, ...props }) => {
  return (
    <h2 className="subtitle" {...props}>
      {text}
    </h2>
  );
};
